import { toWSDateString } from "@wingspanhq/fe-component-library";
import { WSCardHeaderProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSCard/WSCardHeader";

import { DataView } from "../../../shared/components/DataView";
import { getLast4 } from "../../../shared/utils/getLast4";
import { normalizeDateOnly } from "../../../shared/utils/normalizeDateOnly";
import { getTaxIdLabel } from "../../../shared/utils/taxId";
import { FormPartialDataUsPersonInfo } from "./FormPartialUsPersonInfo";

type Props = {
  title?: string;
  formData: FormPartialDataUsPersonInfo;
  onEdit?: () => void;
  header?: WSCardHeaderProps;
};

export const ReviewUSPerson: React.FC<Props> = ({
  title,
  formData,
  onEdit,
  header
}) => {
  return (
    <DataView
      gridColumns={2}
      data={[
        {
          label: "First name",
          value: formData.firstName,
          fsExclude: true
        },
        {
          label: "Middle name",
          value: formData.middleName,
          fsExclude: true
        },
        {
          label: "Last name",
          value: formData.lastName,
          fsExclude: true
        },
        {
          label: getTaxIdLabel("Individual", "US"),
          value: `••• ${getLast4(formData.ssn)}`,
          fsExclude: true
        },
        {
          label: "Became a U.S. person",
          value:
            formData.usPersonSince === "date" && formData.usPersonDate
              ? toWSDateString(
                  normalizeDateOnly(formData.usPersonDate),
                  "monthDayYear"
                )
              : "Always been a U.S. person",
          fsExclude: true
        }
      ]}
      header={header}
      title={title}
      onEdit={onEdit}
    />
  );
};
